export const MINDROOM_SESSION_STORE_KEY = 'mindroom_multi_account_store';
export const MINDROOM_SESSION_STORE_EVENT = 'mindroom-session-store-changed';
